export default __webpack_public_path__ + "images/QS.0365613.png";